import { useMemo } from "react";

import { Column } from "@covertree/ui/table/types";

import {
  RESIDENTS_TABLE_COLUMNS,
  getColumnsToRemove,
  RemovableResidentColumn,
} from "../utils";
import { GetResidentsFilterStatus } from "@graphql/api";

export const useGetResidentsColumns = (
  filter: GetResidentsFilterStatus,
  isCommunityManagerRole: boolean
): Column[] => {
  return useMemo(() => {
    const columnsToRemove = getColumnsToRemove(filter, isCommunityManagerRole);

    return RESIDENTS_TABLE_COLUMNS.filter(
      ({ headerName }) =>
        !columnsToRemove.includes(headerName as RemovableResidentColumn)
    );
  }, [filter, isCommunityManagerRole]);
};
